export const smoothScrollTo = (targetY, duration = 800) => {
    const startY = window.scrollY;
    const distance = targetY - startY;
    const startTime = performance.now();

    const easeOutQuart = (t) =>
      1 - Math.pow(1 - t, 4);

    const step = (currentTime) => {
      const elapsedTime = currentTime - startTime;
      const progress = Math.min(elapsedTime / duration, 1);
      const easedProgress = easeOutQuart(progress);

      window.scrollTo(0, startY + distance * easedProgress);
      if (elapsedTime < duration) {
        requestAnimationFrame(step);
      }
    };

    requestAnimationFrame(step);
  };
